<template>
  <div class="ws-notifications">
    <div class="ws-notifications__list">
      <template v-for="item in list">
        <b-notification v-if="!storage.getItem(item.guid) && !!item.importance"
                        :key="item.guid"
                        class="ws-notifications__item"
                        :type="`is-${getImportance(item.importance).type}`" @close="onClose(item.guid)">
          <div class="has-text-centered" v-html="marked(item.text)"></div>
        </b-notification>
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import marked from 'marked'

export const STANDARD = 'standard'
export const HIGH = 'high'
export const HIGHER = 'higher'

const IMPORTANCE = {
  [STANDARD]: {
    type: 'success'
  },
  [HIGH]: {
    type: 'warning'
  },
  [HIGHER]: {
    type: 'danger'
  }
}

const UPDATE_TIMEOUT = 1000 * 60

class Storage {
  constructor (service = 'de', stage = __stage, entity = 'notification') {
    this.service = service
    this.stage = stage
    this.entity = entity
  }

  get itemKey () {
    return `${this.stage}-${this.service}-${this.entity}`
  }

  setItem (id) {
    localStorage.setItem(`${this.itemKey}-${id}`, id)
  }

  getItem (id) {
    return localStorage.getItem(`${this.itemKey}-${id}`)
  }
}

export default {
  name: 'WsNotifications',
  data () {
    return {
      storage: new Storage()
    }
  },
  computed: {
    ...mapState('notifications', {
      isFindPending: 'isFindPending',
      pagination: 'pagination'
    }),
    ...mapGetters('notifications', {
      getExamById: 'get'
    }),
    ...mapGetters('notifications', {
      list: 'list'
    })
  },
  methods: {
    ...mapActions('notifications', ['find']),
    ...mapMutations('notifications', ['clearAll']),
    async _fetch () {
      try {
        await this.find({ query: { is_active: true } })
      } catch (e) {
        console.log(e)
      }
    },
    marked,
    getImportance (importance) {
      return IMPORTANCE[importance]
    },
    onClose (guid) {
      this.storage.setItem(guid)
    }
  },
  async mounted () {
    await this._fetch()
    setInterval(async () => {
      await this._fetch()
    }, UPDATE_TIMEOUT)
  }
}
</script>

<style lang="scss">
  .ws-notifications__item {
    &.notification {
      margin-bottom: 1px;
      &:not(:last-child) {
        margin-bottom: 1px;
      }
      border-radius: 0;
    }
  }
</style>
